<div class="d-flex flex-column page-content border border-radius w-100">
  <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
    (nzQueryParams)="sort($event)" [nzFooter]="footerTemplate" [nzNoResult]="semDadosTemplate">
    <thead>
      <tr>
        <th nzColumnKey="dataDe" nzShowSort [nzSortFn]="true">Data de Mudança</th>
        <th nzColumnKey="tipoMudancaEntidade" nzShowSort [nzSortFn]="true">Tipo de Mudança</th>
        <th nzColumnKey="statusMudancaEntidade" nzShowSort [nzSortFn]="true">Status</th>
        <th class="text-center">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of dataSet">
        <td>{{ item?.dataMudanca | date: 'dd/MM/yyyy' }}</td>
        <td>{{ item?.tipoMudancaEntidade?.nomeTipoMudancaEntidade }}</td>
        <td>{{ item?.statusMudancaEntidade?.nomeStatusMudancaEntidade }}</td>
        <td class="text-center">
          <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
            <span nz-icon nzType="more" nzTheme="outline"></span>
          </button>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item>
                <a type="button" (click)="editarMovimentacaoSocietaria(item,'visualizar')">Consultar Detalhes</a>
              </li>
              <li nz-menu-item>
                <a type="button" (click)="editarMovimentacaoSocietaria(item,'editar')">Editar</a>
              </li>
            </ul>
          </nz-dropdown-menu>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <ng-template #footerTemplate>
    <section class="d-flex justify-content-end w-100">
      <app-pagination [itemPorPagina]="10"></app-pagination>
    </section>
  </ng-template>
  <ng-template #semDadosTemplate>
    <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
      <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
    </div>
  </ng-template>
</div>
